import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { Job } from 'src/app/core/services/organization/organization.model';

@Component({
  selector: 'app-organization-new-job',
  templateUrl: './organization-new-job.component.html'
})
export class OrganizationNewJob implements OnInit {
  @Input() job: Job;
  @Input() isCreatingNewJob: boolean;

  @Output() submitJob = new EventEmitter();
  @Output() deleteJob = new EventEmitter();
  @Output() cancel = new EventEmitter();

  form: FormGroup = new FormGroup(
    {
      name: new FormControl(null, Validators.required),
      description: new FormControl(null),
      email: new FormControl(null, Validators.email),
      url: new FormControl(null, this.urlValidator()),
      children: new FormControl(null),
      remote: new FormControl(null)
    },
    this.atLeastOne(Validators.required, ['email', 'url'])
  );

  ngOnInit() {
    if (this.job) {
      this.form.patchValue({
        name: this.job.name,
        description: this.job.description,
        email: this.job.email,
        url: this.job.url,
        children: this.job.children,
        remote: this.job.remote
      });
    }
  }

  onChangeDescription(description: string) {
    console.log('onChangeDescription: ', description);

    this.form.patchValue({
      description
    });
  }

  onSubmit() {
    this.submitJob.emit({
      ...this.form.value,
      id: this.job?.id
    });
  }

  onCancel() {
    this.cancel.emit();
  }

  private atLeastOne(validator: ValidatorFn, controls: string[] = null) {
    return (group: FormGroup): ValidationErrors | null => {
      console.log('atLeastOne: ', group.controls);

      if (!controls) {
        controls = Object.keys(group.controls);
      }

      const hasAtLeastOne =
        group &&
        group.controls &&
        controls.some((k) => !validator(group.controls[k]));

      return hasAtLeastOne
        ? null
        : {
            atLeastOne: true
          };
    };
  }

  urlValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null;
      }

      if (!/^https?:\/\/\S+\.\S+$/.test(control.value)) {
        return { url: { value: control.value } };
      }

      const input: HTMLInputElement = document.createElement('input');
      input.type = 'url';
      input.value = control.value;
      const isValid: boolean = input.checkValidity();

      console.log('isValid: ', isValid, control.value);

      return isValid ? null : { url: { value: control.value } };
    };
  }

  delete(job: Job) {
    this.deleteJob.emit(job);
  }
}
